import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../api/axiosInstance';

export const fetchCartInfo = createAsyncThunk(
    'cart/fetchCartInfo',
    async ({ promocode } = {}, { rejectWithValue }) => {
        try {
            // Get promo code from localStorage if not passed as parameter
            const savedPromo = promocode || localStorage.getItem('hf_promoCode');

            let url = '/cart/cart-info';
            if (savedPromo) {
                url += `?promo_code=${encodeURIComponent(savedPromo)}`;
            }

            const { data } = await axiosInstance.get(url);
            return data;
        } catch (error) {
            return rejectWithValue('Failed to fetch cart info');
        }
    },
);

export const addToCart = createAsyncThunk(
    'cart/addToCart',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post(`/cart/add-to-cart`, payload);

            // Check if the response indicates an error (status: 0)
            if (data.status === 0) {
                return rejectWithValue(data.message || 'Failed to add item to cart');
            }

            return data;
        } catch (error) {
            const errorMessage = error?.response?.data?.message || 'Failed to add item to cart';
            return rejectWithValue(errorMessage);
        }
    },
);

export const updateToCart = createAsyncThunk(
    'cart/updateToCart',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post(`/cart/update-cart`, payload);

            // Check if the response indicates an error (status: 0)
            if (data.status === 0) {
                return rejectWithValue(data.message || 'Failed to update cart');
            }

            return data;
        } catch (error) {
            const errorMessage = error?.response?.data?.message || 'Failed to update cart';
            return rejectWithValue(errorMessage);
        }
    },
);

export const removeCartByProductId = createAsyncThunk(
    'cart/removeCartByProductId',
    async (product_id, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.delete(
                `/cart/remove-cart-by-product-id?product_id=${product_id}`,
            );
            return data;
        } catch (error) {
            return rejectWithValue('Failed to fetch user');
        }
    },
);

export const validatePromoCode = createAsyncThunk(
    'cart/validatePromoCode',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post(`/checkout/check-promo-code`, payload);
            return data;
        } catch (error) {
            return rejectWithValue('Failed to validate promo code.');
        }
    },
);

export const savePreference = createAsyncThunk(
    'cart/savePreference',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post(`/orders/save-order-preference`, payload);
            return data;
        } catch (error) {
            return rejectWithValue('Failed to fetch user');
        }
    },
);

// Add to cart to delivery partner
export const partnersCart = createAsyncThunk(
    'delivery-partners/partner-cart-items',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post(
                '/delivery-partners/partner-cart-items',
                payload,
            );
            return data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data.message || 'Failed to add items to partner cart',
            );
        }
    },
);
